import React, { useEffect, useState } from 'react';
import * as Cookies from 'js-cookie';
import { loadTrackingScripts } from 'services/tracking';
import styles from './styles.module.scss';

const CONSENT_COOKIE_NAME = 'cookie_consent';
const CONSENT_COOKIE_EXPIRY_DAYS = 365;
const PRIVACY_POLICY_URL = 'https://www.reponestrength.com/privacy';

export default () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = Cookies.get(CONSENT_COOKIE_NAME);
        if (consent === 'accepted') {
            loadTrackingScripts();
        } else if (consent !== 'rejected') {
            setVisible(true);
        }
    }, []);

    const respond = (value) => {
        Cookies.set(CONSENT_COOKIE_NAME, value, {
            expires: CONSENT_COOKIE_EXPIRY_DAYS,
            secure: true,
            sameSite: 'strict',
        });
        if (value === 'accepted') {
            loadTrackingScripts();
        }
        setVisible(false);
    };

    if (!visible) {
        return null;
    }

    return (
        <div className={styles.banner}>
            <div className={styles.text}>
                We use cookies to improve your experience and understand how RepOne is used.
                Read our <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className={styles.link}>Privacy Policy</a> to learn more.
            </div>
            <div className={styles.actions}>
                <button className={styles.reject} onClick={() => respond('rejected')}>Reject</button>
                <button className={styles.accept} onClick={() => respond('accepted')}>Accept</button>
            </div>
        </div>
    );
};
